export default __webpack_public_path__ + "static/media/PAGO.58629062.png";